import angular from "angular";
// Dependency on core modules exists because the locale directive needs access to the data services.
import { CoreModule } from '../../core/core.module';
import { DragDropContainerDirective } from "./drag-drop/drag-drop-container.directive";
import { DragDropPayloadDirective } from "./drag-drop/drag-drop-payload.directive";
import { FileModelDirective } from "./file-model.directive";
import { FlexTableModule } from "./flex-table/flex-table.module";
import { IndeterminateCheckboxDirective } from "./indeterminate-checkbox.directive";
import { IsolateFormDirective } from "./isolate-form.directive";
import { LocaleDirective } from "./locale.directive";
import { MaskedSecretDirective } from "./masked-secret.directive";
import { NoDirtyCheckDirective } from "./no-dirty-check.directive";
import { PartialSrcDirective } from "./partial-src.directive";
import { StandbyInputDirective } from "./standby-input.directive";
import { StatePreserveFocusDirective } from "./state-preserve-focus.directive";
import { StickyDirective } from "./sticky";
import { TrixWysiwygDirective } from './trix-wysiwyg.directive';
import { VirtualLimitDirective } from "./virtual-limit.directive";

export const DirectivesModule = angular
    .module("apex.common.directives", [
        CoreModule,
        FlexTableModule
    ])
    .directive("apexDragDropContainer", DragDropContainerDirective)
    .directive("apexDragDropPayload", DragDropPayloadDirective)
    .directive("apexFileModel", FileModelDirective)
    .directive("apexIndeterminateCheckbox", IndeterminateCheckboxDirective)
    .directive("apexIsolateForm", IsolateFormDirective)
    .directive("apexLocale", LocaleDirective)
    .directive("apexMaskedSecret", MaskedSecretDirective)
    .directive("apexNoDirtyCheck", NoDirtyCheckDirective)
    .directive("apexPartialSrc", PartialSrcDirective)
    .directive("apexStandbyInput", StandbyInputDirective)
    .directive("apexStatePreserveFocus", StatePreserveFocusDirective)
    .directive("apexSticky", StickyDirective)
    .directive("apexWysiwyg", TrixWysiwygDirective)
    .directive("apexVirtualLimit", VirtualLimitDirective)
    .name
